//小红书传播表现

//合作笔记互动中位数
export const cooperateChatMid = [
	{
		itemName: '2000以上',
		itemValue: '2000',
	},
	{
		itemName: '1000-2000',
		itemValue: '1000-2000',
	},
	{
		itemName: '500-1000',
		itemValue: '500-1000',
	},
	{
		itemName: '200-500',
		itemValue: '200-500',
	},
	{
		itemName: '100-200',
		itemValue: '100-200',
	},
];
//合作笔记阅读中位数
export const cooperateReadMid = [
	{
		itemName: '5万以上',
		itemValue: '50000',
	},
	{
		itemName: '1万-5万',
		itemValue: '10000-50000',
	},
	{
		itemName: '0.5万-1万',
		itemValue: '5000-10000',
	},
	{
		itemName: '0.1万-0.5万',
		itemValue: '1000-5000',
	},
];
//日常笔记互动中位数
export const dailyChatMid = [
	{
		itemName: '2000以上',
		itemValue: '2000',
	},
	{
		itemName: '1000-2000',
		itemValue: '1000-2000',
	},
	{
		itemName: '500-1000',
		itemValue: '500-1000',
	},
	{
		itemName: '200-500',
		itemValue: '200-500',
	},
	{
		itemName: '100-200',
		itemValue: '100-200',
	},
];
//日常笔记阅读中位数
export const dailyReadMid = [
	{
		itemName: '5万以上',
		itemValue: '50000',
	},
	{
		itemName: '1万-5万',
		itemValue: '10000-50000',
	},
	{
		itemName: '0.5万-1万',
		itemValue: '5000-10000',
	},
	{
		itemName: '0.1万-0.5万',
		itemValue: '1000-5000',
	},
];

// -----------------达人详情-返回路径-----------------

// - 工作台-达人销售排行榜
export const WORKBENCH_RANK = { source: 'salesRank', path: '/ranking/issueTalent/list?days=30' };

// - 团队管理-业绩管理
export const TEAM_MANAGEMENT = { source: 'performanceManagement', path: '/teamManage/achievements' };

// - 工作台-排期日历
export const WORKBENCH_CALENDAR = { source: 'schedulingCalendar', path: '/home/index' };

// - 团长-团长协作
export const HEADMAN_COLLABORATION = { source: 'collaboration', path: '/channel/collaboration/list' };

// - 内容库-合作内容
export const CONTENT_COOPERATION = { source: 'shotvideo', path: '/library/shotvideo/list' };

// - 合作进度
export const COOPERATION_PROGRESS = {
	source: 'cooperationProgress',
	path: '/cooperationProgressManage/cooperationProgress/list',
};

// - 样品订单
export const SAMPLE_ORDER = { source: 'sampleOrder', path: '/sample/list' };

// - 达人crm-跟进记录
export const FOLLOW_UP_RECORDS = { source: 'followUpRecords', path: '/talentCRM/followUpRecords/list' };

// - 达人crm-我的达人
export const MY_TALENT = { source: 'myTalent', path: '/talentCRM/myTalent' };

// - 达人crm-重点关注达人
export const EMPHASIS_TALENT = { source: 'emphasisTalent', path: '/talentCRM/emphasisTalent' };

// - 达人crm-联系人
export const CONTACTS = { source: 'contacts', path: '/talentCRM/contacts' };

// - 达人crm-团队公海
export const GROUP_SEAS = { source: 'groupSeas', path: '/talentCRM/groupSeas' };

// - 达人CRM-找达人
export const CLUE_SEAS = { source: 'clueSeas', path: '/talentCRM/clueSeas' };

export const TALENT_DETAIL_PATH = [
	WORKBENCH_RANK,
	TEAM_MANAGEMENT,
	WORKBENCH_CALENDAR,
	HEADMAN_COLLABORATION,
	CONTENT_COOPERATION,
	COOPERATION_PROGRESS,
	SAMPLE_ORDER,
	FOLLOW_UP_RECORDS,
	MY_TALENT,
	EMPHASIS_TALENT,
	CONTACTS,
	GROUP_SEAS,
	CLUE_SEAS,
];

export default {};
